import React from 'react'
import '../assets/css/CropOption.scss'
import { ReactComponent as IconRight } from '../assets/icons/crop/Right.svg'
import { ReactComponent as IconCancel } from '../assets/icons/crop/Cancel.svg'

const CropOption = ({ handleCrop, cancelCrop }) => {
    return (
        <div className='toolpanel visible cropToolPanel'>
            <div className='holder sbar'>
                <div className='shapes'>
                    <div className='button' onClick={() => handleCrop()}>
                        <IconRight />
                    </div>
                    <div className="button" onClick={() => cancelCrop()}>
                        <IconCancel />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CropOption
